/*
 * @Author: your name
 * @Date: 2021-06-07 20:40:40
 * @LastEditTime: 2026-10-14 17:21:12
 * @LastEditors: zl21 602659667@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /burgeon-project-logic/config/module/modal/organization.config.js
 */
// 组织中心
export default {
  ORGANIZATION_PERMISSION_GROUP: {
    component: () => import(
      /* webpackChunkName: 'OrganizationCenterModal' */
      '@/views/modal/organizationCenter/organizationPermissionGroup.vue'
    ),
  },
  ORGPERMISSIONS: {
    component: () => import(
      /* webpackChunkName: 'OrganizationCenterModal' */
      '@/views/modal/organizationCenter/orgPermissionNew.vue'
    ),
  },
  //重置密码
  USERS_RESET_PWD: {
    component: () => import(
      /* webpackChunkName: 'OrganizationCenterModal' */
      '@/views/modal/organizationCenter/users_reset_pwd.vue'
    ),
  },
  // 门店档案 - 动作定义(批量修改(导入))
  RSTOREIMPORT: {
    // component: () => import('@/views/modal/organizationCenter/rstoreImport.vue')
    component: () => import('@/component/commonPages/importPop')
  },

};
